import React from 'react'
import { useParams } from 'react-router-dom'
import { CCol, CRow, CContainer } from '@coreui/react'
import { AppContentSitio, AppFooter, AppHeaderSitio } from '../components/index'

const PaginaSitiosLayout = () => {
  const { id, sitio } = useParams()

  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeaderSitio id={id} sitio={sitio} />
        <div className="body flex-grow-1 mb-5">
          <CContainer fluid className="container-er">
            <CRow>
              <CCol>
                <AppContentSitio sitio={sitio} />
              </CCol>
            </CRow>
          </CContainer>
        </div>
        <AppFooter sitio={sitio} home={false} />
      </div>
    </div>
  )
}

export default PaginaSitiosLayout
